import {IExportFlow} from "../../../index";

export namespace nsParentPath {

    export enum TYPE {
        Absolute = 1,
        DepartmentReferenceId = 2,
        DepartmentReferenceAttribute = 3
    }

    export function getType(expression: string, sourceattribute: string): number {
        if (!sourceattribute && isNaN(Number(expression))) {
            return TYPE.Absolute;
        }

        if (!sourceattribute && !isNaN(parseInt(expression))) {
            return TYPE.DepartmentReferenceId;
        }

        if (sourceattribute) {
            return TYPE.DepartmentReferenceAttribute;
        }
        return TYPE.Absolute;
    }

    export function getTypeFromExportFlow(exportflow: IExportFlow): number {
        let expression = exportflow.expression;
        let sourceattribute = exportflow.sourceattribute;
        return getType(expression, sourceattribute);
    }

    export function getTypeLabel(expression: string, sourceattribute: string): string {
        switch (getType(expression, sourceattribute)) {
            case TYPE.Absolute:
                return "absolute path";
            case TYPE.DepartmentReferenceId:
                return "department reference by id";
            case TYPE.DepartmentReferenceAttribute:
                return "department reference by attribute";
            default:
                return "unknown";
        }
    }

    export function getTypeLabelFromExportFlow(exportflow: IExportFlow): string {
        let expression = exportflow.expression;
        let sourceattribute = exportflow.sourceattribute;
        return getTypeLabel(expression, sourceattribute);
    }

    export const AVAILABLE_TYPES = [
        {id: TYPE.Absolute, label: "absolute path"},
        {id: TYPE.DepartmentReferenceId, label: "department reference by id"},
        {id: TYPE.DepartmentReferenceAttribute, label: "department reference by attribute"}
    ];

}
